module.exports = __webpack_public_path__ + "img/professionals-cover.bb060018.webp";